const load = () => {window.location = '/your-project/thankyou'}

const thankyou = typeof ga !== 'undefined' && ga.loaded
    ? () => ga('send', 'event', 'project', 'submit', {hitCallback:load})
    : load

module.exports = thankyou



// WEBPACK FOOTER //
// ./src/components/thankyou.js